<template>
	<div style="height: 100%">
		<div class="sa-flexbox" style="padding-bottom: 20px">
			<div class="sa-flexbox-header"></div>
			<div class="sa-flexbox-body">
				<div class="b-table-sticky-header">
					<span class="sa-flexbox-body-title">Consensi</span>
					<!--secondary btn-toolbar sa-margin-right float-sm-right-->
					<b-button variant="outline-success outline-primary-noborder sa-margin-right float-sm-right"
						@click="onClickAggiungiAccettazioneConsenso" class="mb-2">
						<i class="fas fa-plus"></i>
						Aggiungi
					</b-button>
					<b-table sticky-header ref="table" stacked="sm" striped hover :items="accettazioneCosensiItems"
						:fields="accettazioneCosensiFields" :current-page="1" :per-page="perPage" :key="listKey"
						sort-icon-left head-variant="light" class="sa-b-table">
						<template #cell(index)="row">
							{{ row.index + 1 }}
						</template>
						<template #cell(actions)="{ item }">
							<b-container class="bv-example-row">
								<b-button v-if="checkConsensiFirmati(item)" size="sm" variant="outline-success"
									disabled>
									<font-awesome-icon icon="check"></font-awesome-icon>
								</b-button>
								<b-button v-else size="sm" variant="outline-danger" disabled>
									<font-awesome-icon icon="check"></font-awesome-icon>
								</b-button>
								<sign-print-button-component
									v-if="item.statoAttuale !== 'FIRMATO'"></sign-print-button-component>
								<b-button v-if="item.statoAttuale !== 'FIRMATO'" v-b-tooltip.hover
									title="Cambia in Firmato" size="sm" class="no-text" variant="outline-secondary"
									@click="onFirma(item)">
									<i class="fas fa-signature"></i>
								</b-button>
								<print-component :documentRepository="true" :idRisorsa="item.id" :typeButton="'small'">
								</print-component>
							</b-container>
						</template>
					</b-table>
				</div>
			</div>
			<div class="sa-flexbox-footer" style="background-color: ciano">
				<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
					<b-col lg="3">
						<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
					</b-col>
					<b-col lg="9">
						<b-pagination v-model="currentPage" :total-rows="accettazioneCosensiRows" :per-page="perPage"
							align="right" size="sm"></b-pagination>
					</b-col>
				</b-row>
			</div>
		</div>
		<consensi-list-modal-component ref="cmpConsensiListModalComponent"></consensi-list-modal-component>
		<sign-print-component ref="cmpSignPrintComponent" @onshown="onShownCmpSignPrintComponent"
			@confermaSelezione="onConfermaSelezioneCmpSignPrintComponent">
			<template slot="body-component">
				<consensi-list-component :selectable="true" ref="cmpConsensiListComponent"
					@rowSelected="onRowSelected"></consensi-list-component>
			</template>
		</sign-print-component>
	</div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
import AccettazioneConsensiMixin from "../mixins/AccettazioneConsensiMixin";
import PrintComponent from "../../utility/components/PrintComponent.vue";
import ConsensiListModalComponent from "../../consensi/components/ConsensiListModalComponent.vue";
import SignPrintComponent from "../../utility/components/SignPrintComponent.vue";
import ConsensiListComponent from "../../consensi/components/ConsensiListComponent.vue";
import SignPrintButtonComponent from "../../utility/components/SignPrintButtonComponent.vue";
export default {
	mixins: [UtilityMixin, AccettazioneConsensiMixin],
	components: { PrintComponent, SignPrintComponent, ConsensiListComponent, ConsensiListModalComponent, SignPrintButtonComponent },
	data() {
		return {
			rows: 0,
			perPage: 50,
			currentPage: 1,
			idAccettazione: null,
			codiceStruttura: null,
			sezione: null,
			documentoFirma: {},
			pathResource: "/accettazioneconsensi",
			pathResourcePrintConsensi: "/accettazioneconsensi/print",
			pathResourceConsensi: "/consensi",
			signedPdfViewer: null,
			listKey: 0,
			nomeFile: "Consenso_",
			descrizione: "Consenso",
			tipoDocumento: "Consenso",
			codiceApplicativo: "NURITY-01",
			jsonAccettazione: null,
			dataModel: null,
			consensoSelezionato: null,
		};
	},
	mounted() {
		console.log(this.jsonAccettazione);
	},
	methods: {
		setDati(idAccettazione, jsonAccettazione, sezione) {
			console.log(jsonAccettazione);

			console.log("se dati", idAccettazione, sezione);

			let me = this;
			me.idAccettazione = idAccettazione;
			me.jsonAccettazione = jsonAccettazione;
			me.sezione = sezione;
			this.accettazioneConsensiFiltro.page = me.currentPage;
			this.accettazioneConsensiFiltro.forPage = me.perPage;
			this.accettazioneConsensiFiltro.idAccettazione = me.idAccettazione;
			this.accettazioneConsensiFiltro.codiceStruttura = me.jsonAccettazione.codiceStruttura;
			this.accettazioneConsensiFiltro.sezione = me.sezione;
			me.accettazioneConsensiLoadData();
		},
		checkConsensiFirmati(item) {
			return item.statoAttuale !== "FIRMATO" ? false : true;
		},
		linkPrintData(item) {
			let me = this;
			let returnValue = me.pathResourcePrintConsensi + "/" + item.id;
			return returnValue;
		},
		onClickAggiungiAccettazioneConsenso() {
			console.log(this.jsonAccettazione);

			this.accettazioneConsensoNew();
			this.dataModel = {
				nome: this.jsonAccettazione.accettazioneAnagrafica.nome,
				cognome: this.jsonAccettazione.accettazioneAnagrafica.cognome,
				comuneNascita: this.jsonAccettazione.accettazioneAnagrafica.comuneNascita,
				dataNascita: this.formatDate(this.jsonAccettazione.accettazioneAnagrafica.dataNascita),
			};
			this.$refs.cmpSignPrintComponent.show();
		},
		onClickFirmaConsenso(item) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResourcePrintConsensi + "/" + item.nomeConsenso;
			axios.get(link)
				.then((response) => {
					me.documentoFirma = item;
					me.documentoFirma.base64 = response.data.data;
					this.$emit("afterLoadData");
				})
				.catch(() => {
					this.$emit("afterLoadData");
				});
		},
		onPrint() {
			console.log("Print");
		},
		onModifica() {
			console.log("Modifica");
		},
		onRowSelected(consenso) {
			this.consensoSelezionato = null;
			if (consenso) {
				this.consensoSelezionato = consenso;
				this.creaConsenso(consenso);
			} else {
				this.$refs.cmpSignPrintComponent.setData("---", null);
			}
		},
		onShownCmpSignPrintComponent() {
			this.$refs.cmpConsensiListComponent.loadData();
		},
		creaConsenso(consenso) {
			let item = {
				idConsenso: consenso.id,
				data: JSON.stringify(this.dataModel),
			};
			this.openShowModalLoading();
			axios.post(process.env.VUE_APP_PATH_API + this.pathResourceConsensi + "/create", item)
				.then((response) => {
					this.closeShowModalLoading();
					this.pdfViewer = "data:application/pdf;base64," + response.data.data;
					this.$refs.cmpSignPrintComponent.setData(consenso.nomeConsenso, this.pdfViewer);
				})
				.catch((err) => {
					this.closeShowModalLoading();
					if (err.response.data) {
						this.$bvToast.toast(err.response.data.messaggio, {
							title: "Attenzione",
							variant: "danger",
							solid: true,
						});
					}
					console.log(err);
				});
		},
		onConfermaSelezioneCmpSignPrintComponent(pdf) {
			this.accettazioneConsenso.idAccettazione = this.jsonAccettazione.id;
			this.accettazioneConsenso.idConsenso = this.consensoSelezionato.id;
			this.accettazioneConsenso.nomeConsenso = this.consensoSelezionato.nomeConsenso;
			this.accettazioneConsenso.pdfConsenso = pdf;
			this.accettazioneConsensoSave();
		},
		onFirma(item) {
			this.accettazioneConsensoCambiaStato(item.id, "FIRMATO");
		},
	},
};
</script>

<style></style>
